import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { RecordData, MonitoringDayData } from '../../types';

@Injectable()
export class StoreUserService {

  public static readonly TAG = "StoreUserService";

  private loadedUserRecords: { recordsData: RecordData[]; monitoringDaysData: MonitoringDayData[] };
  private loadedUserRecordsBehaviorSubject: BehaviorSubject<{ recordsData: RecordData[]; monitoringDaysData: MonitoringDayData[] }>;
  private loadedUserRecordsObservable: Observable<{ recordsData: RecordData[]; monitoringDaysData: MonitoringDayData[] }>;

  private selectedUser: User;
  private selectedUserBehaviorSubject: BehaviorSubject<User>;
  private selectedUserObservable: Observable<User>;

  constructor() {

    this.loadedUserRecordsBehaviorSubject = new BehaviorSubject<{ recordsData: RecordData[]; monitoringDaysData: MonitoringDayData[] }>({ recordsData: null, monitoringDaysData: null});
    this.loadedUserRecordsObservable = this.loadedUserRecordsBehaviorSubject.asObservable();

    this.selectedUserBehaviorSubject = new BehaviorSubject<User>(null);
    this.selectedUserObservable = this.selectedUserBehaviorSubject.asObservable();
  }

  setSelectedUser(user: User): void {

    this.selectedUser = user;
    if (user == null) {
      sessionStorage.removeItem('gokuri.user');
    } else {
      sessionStorage.setItem('gokuri.user', JSON.stringify(user));
    }

    this.selectedUserBehaviorSubject.next(user);
  }

  getSelectedUser(): User {
    return this.selectedUser || JSON.parse(sessionStorage.getItem('gokuri.user')) as User;
  }

  getSelectedUserObservable(): Observable<User> {
    return this.selectedUserObservable;
  }

  setLoadedUserRecords(records: { recordsData: RecordData[]; monitoringDaysData: MonitoringDayData[] }): void {

    this.loadedUserRecords = records;
  }

  getLoadedUserRecords(): { recordsData: RecordData[]; monitoringDaysData: MonitoringDayData[] } {
    return this.loadedUserRecords;
  }

  getLoadedUserRecordsObservable(): Observable<{ recordsData: RecordData[]; monitoringDaysData: MonitoringDayData[] }> {
    return this.loadedUserRecordsObservable;
  }
}

export class User {
  userId: string;
  userName: string;
  viewValue: string;
}
